// DocumentsZone — German. 'Open', 'Loading…' and 'not collected' live in common.de.ts and are
// not repeated here. The raster's cell names come from `labelFor`, never from this file.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Documents': 'Dokumente',
  'the PDFs a profile run read and kept, with the cells that rest on them':
    'die PDF, die ein Profillauf gelesen und aufbewahrt hat, mit den Zellen, die darauf beruhen',

  // the columns
  'Year': 'Jahr',
  'Source': 'Quelle',
  'Fetched': 'Abgerufen',
  'Size': 'Grösse',
  'Cited by': 'Zitiert von',
  '{n} bytes': '{n} Bytes',
  'Open the kept PDF as the run read it': 'Das aufbewahrte PDF öffnen, wie der Lauf es gelesen hat',
  'no cell cites it': 'keine Zelle zitiert es',

  // the states
  'This server does not report kept documents yet. A profile run keeps the annual report it reads; once the record answers with its documents they are listed here.':
    'Dieser Server meldet noch keine aufbewahrten Dokumente. Ein Profillauf bewahrt den gelesenen Jahresbericht auf; sobald der Bestand seine Dokumente meldet, stehen sie hier.',
  'No document is kept for this organisation. A profile fill that finds an annual report reads the PDF in the same run and keeps it here, beside the cells it filled.':
    'Für diese Organisation ist kein Dokument aufbewahrt. Ein Profillauf, der einen Jahresbericht findet, liest das PDF im selben Lauf und bewahrt es hier auf, neben den Zellen, die er gefüllt hat.',
}, 'DocumentsZone');
